import { createContentPropTypes } from '../../../helpers/content';

const content = {
	international: 'International',
	typeLabel: 'Type',
	fromLabel: 'From',
	toLabel: 'To',
	amountLabel: 'Amount being sent',
	debitAmountLabel: 'Debit amount',
	refLabel: 'Reason for payment',
	exchangeRate: 'Exchange Rate',
	bookedRate: 'Booked Rate',
	feesLabel: 'Payment fees',
	submissionDateLabel: 'Payment submission date',
	settlementDateLabel: 'Estimated earliest settlement date',
	createdByLabel: 'Created by',
	createdOnLabel: 'Last updated on',
	indicativeExchangeRateLabel: 'Indicative exchange rate',
	exchangeRateLabel: 'Exchange rate',
	authorisedBy: 'Authorised by',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
